import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Apply from "@/pages/Apply";
import {
  PersonalFinancePage, BusinessFinancePage, LoansPage,
  InstitutionalLendingPage,
} from "@/pages/ProductPages";
import {
  PersonalLoansPage, DebtConsolidationPage, EmergencyLoansPage, MedicalLoansPage,
  HomeImprovementPage, AutoLoansPage, BusinessLoansPage,
} from "@/pages/LoanPages";

function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    document.title = "Elevate Financial · Transparent Lending Information";
    if (hash) {
      const id = hash.replace("#", "");
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
      return () => clearTimeout(t);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);
  return null;
}

function AppRouter() {
  return (
    <>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/apply" element={<Layout><Apply /></Layout>} />

        {/* Detailed loan product pages */}
        <Route path="/loans/personal" element={<Layout><PersonalLoansPage /></Layout>} />
        <Route path="/loans/debt-consolidation" element={<Layout><DebtConsolidationPage /></Layout>} />
        <Route path="/loans/emergency" element={<Layout><EmergencyLoansPage /></Layout>} />
        <Route path="/loans/medical" element={<Layout><MedicalLoansPage /></Layout>} />
        <Route path="/loans/home-improvement" element={<Layout><HomeImprovementPage /></Layout>} />
        <Route path="/loans/auto" element={<Layout><AutoLoansPage /></Layout>} />
        <Route path="/loans/business" element={<Layout><BusinessLoansPage /></Layout>} />

        {/* Existing informational pages */}
        <Route path="/personal-finance" element={<Layout><PersonalFinancePage /></Layout>} />
        <Route path="/business-finance" element={<Layout><BusinessFinancePage /></Layout>} />
        <Route path="/loans" element={<Layout><LoansPage /></Layout>} />
        <Route path="/institutional-lending" element={<Layout><InstitutionalLendingPage /></Layout>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster richColors closeButton position="top-right" />
    </BrowserRouter>
  );
}
